import React, { useState } from "react";
import { getCookie } from "../../utils/cookies";
import axios from "axios";
import { Button } from "react-bootstrap";
import { ClipboardCheckFill } from "react-bootstrap-icons";
import { Modal } from "react-bootstrap";
import AlertDialog from "../../ui/alerts/AlertDialog";
import { BACKGROUND_CHECK_STATUS } from "../../constants/ BACKGROUND_CHECK_STATUS";
export default function SetBackgroundCheckReview({ data, handleSuccess }) {
  // Form Modal state
  const [showSetBackgroundCheckReview, setShowSetBackgroundCheckReview] =
    useState(false);

  // Show and Hide Form Modal
  const handleClose = () => setShowSetBackgroundCheckReview(false);
  const handleShow = () => setShowSetBackgroundCheckReview(true);

  const [isLoading, setIsLoading] = useState(true);

  // Success Dialog State
  const [showSuccess, setShowSuccess] = useState(false);

  // Error Dialog State
  const [showError, setShowError] = useState(false);

  // UPDATE
  const updateBackgroundCheckStatus = async (id: number) => {
    try {
      const JWT = await getCookie("ea1-auth");
      const { data: userResp } = await axios(
        `https://ea1-dev.azurewebsites.net/api/userServiceProviderDetail/${id}`,
        {
          method: "PATCH",
          data: {
            background_check_status: BACKGROUND_CHECK_STATUS.IN_REVIEW,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: JWT,
          },
        }
      );
      if (userResp) {
        handleSuccess(userResp);
      }
      setIsLoading(false);

      // Confirmation Modal Hide State (follow Delete method)
      setShowSetBackgroundCheckReview(false);

      // Success Alert Popup
      setShowSuccess(true);
    } catch (e) {
      console.log(e);
      setIsLoading(false);

      // Confirmation Modal Hide State
      setShowSetBackgroundCheckReview(false);

      // Error Alert Popup
      setShowError(true);
    }
  };
  const approveModal = (
    <Modal
      show={showSetBackgroundCheckReview}
      backdrop='static'
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Set Background Check to In Review</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Select CONFIRM below to confirm that the provider {data.first_name}{" "}
        {data.last_name} has submitted their background check to{" "}
        <a href='https://secure.us2.sterlingcheck.app/sys/' target='_blank'>
          Sterling Connect
        </a>
        .
      </Modal.Body>
      <Modal.Footer>
        <Button variant='outline-dark' onClick={handleClose}>
          Cancel
        </Button>
        <Button
          type='submit'
          variant='success'
          onClick={() => updateBackgroundCheckStatus(data.id)}
        >
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );

  const successAlert = (
    <Modal
      show={showSuccess}
      onHide={() => {
        setShowSuccess(false);
      }}
      backdrop='static'
    >
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#00E676" }}
      ></Modal.Header>
      <AlertDialog
        title={"Success!"}
        message={`The providers background check status is now In Review. Once Sterling has completed the provider's background check, set their background check status to Approved or Rejected.`}
      />
    </Modal>
  );

  const errorAlert = (
    <Modal
      show={showError}
      onHide={() => {
        setShowError(false);
      }}
      backdrop='static'
      size='lg'
    >
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#FF1744" }}
      ></Modal.Header>
      <AlertDialog
        title={"Error!"}
        message={"There was an error updating Background Check status."}
      />
    </Modal>
  );

  return (
    <>
      <Button variant='outline-dark' onClick={handleShow}>
        <ClipboardCheckFill
          size={25}
          style={{ marginRight: 5, marginBottom: 6 }}
        />
        Waiting for Approval
      </Button>
      {approveModal}
      {successAlert}
      {errorAlert}
    </>
  );
}
